import moment from "moment";

export const calcularDiferencaEmMeses = (inicio: string, fim: string) => {
    const dataFim = moment(fim);
    const dataInicio = moment(inicio);
    const diferencaMeses = dataFim.diff(dataInicio, 'months');
    return diferencaMeses;
}